module.exports = __webpack_public_path__ + "img/plus.98a54c4f.svg";